import { environment } from '../../environments/environment'
// All REST API endpoints live under `/api` so a Cloud Run nginx sidecar can
// reverse-proxy `/api/*` to the Node backend while serving the SPA at `/`.
// Keep the `environment.server` mechanism intact — just append `/api` once.
const server = `${environment.server}/api`

export const Api = {
  master: {
    checkDbAvailable: `${server}/master/check-db-available`,
    register: `${server}/master/register`
  },
  auth: {
    login: `${server}/auth/log-in`,
    logInByToken: `${server}/auth/log-in-by-token`,
    role: `${server}/auth/role`,
    profile: `${server}/auth/profile`,
    permission: `${server}/auth/permission`,
    sendResetPasswordLink: `${server}/auth/send-reset-password-link`,
    resetPassword: `${server}/auth/reset-password`
  },
  inventory: {
    writeOff: {
      get: `${server}/inventory/write-offs/get`,
      update: `${server}/inventory/write-offs/update`
    },
    item: {
      search: `${server}/inventory/item/search`,
      getById: `${server}/inventory/item/get-by-id`,
      flag: `${server}/inventory/item/toggle-flag`,
      mark: `${server}/inventory/item/toggle-mark`,
      update: `${server}/inventory/item/update`,
      deleteById: `${server}/inventory/item/delete-by-id`,
      writeOff: `${server}/inventory/item/write-off`,
    },
    summary: `${server}/inventory/summary`,
    procure: {
      analysis: `${server}/inventory/procure-analysis`
    },
    order: {
      place: `${server}/orders/place`,
    }
  },
  batch: {
    search: `${server}/batch/search`,
    getItems: `${server}/batch/items`,
    getById: `${server}/batch/get-by-id`,
    updateInfo: `${server}/batch/update-info`,
    updatePurchaser: `${server}/batch/update-purchaser`,
    updateExchangeRate: `${server}/batch/update-exchange-rate`,
    updateShippingFee: `${server}/batch/update-shipping-fee`,
    updateLocation: `${server}/batch/update-location`,
    updateTrackingNumbers: `${server}/batch/update-tracking-numbers`,
    getTrackingNumbers: `${server}/batch/get-tracking-numbers`,
    deleteTrackingNumber: `${server}/batch/delete-tracking-number`,
    getReceipts: `${server}/batch/get-receipts`,
    changeItemLocation: `${server}/batch/change-item-location`,
    addReceipts: `${server}/batch/add-receipts`,
    toggleTrackingNumberStatus: `${server}/batch/toggle-tracking-number-status`,
    delete: `${server}/batch/delete-batch`,
    mergeBatches: `${server}/batch/merge-batches`,
    changeItemsBatch: `${server}/batch/change-items-batch`,
    item: {
      cycleLocation: `${server}/batch/item/cycle-location`,
      changeBatchNumber: `${server}/batch/item/change-items-to-batch-number`
    }
  },
  finance: {
    otherIncome: `${server}/finance/get-other-income`,
    addIncome: `${server}/finance/add-income`,
    updateIncome: `${server}/finance/update-income`,
    deleteIncome: `${server}/finance/delete-income`,
    team: {
      getMembers: `${server}/finance/team/get-users`,
      getMemberTrans: `${server}/finance/team/get-user-trans`,
      addTran: `${server}/finance/team/add-tran`,
      updateTran: `${server}/finance/team/update-tran`,
      deleteTran: `${server}/finance/team/delete-tran`
    },
    sales: {
      getOrders: `${server}/finance/sales/get-orders`,
      getOrder: `${server}/finance/sales/get-order`,
      deleteOrder: `${server}/finance/sales/delete-order`,
      updateOrder: `${server}/finance/sales/update-order`,
      getSoldItem: `${server}/finance/sales/get-sold-item`,
      returnItem: `${server}/finance/sales/return-item`,
      summary: `${server}/finance/sales/get-summary`
    }
  },
  income: {
    getOther: `${server}/finance/income/get-other`,
    add: `${server}/finance/income/add`,
    edit: `${server}/finance/income/update`,
    delete: `${server}/finance/income/delete`
  },
  expense: {
    getWithinDates: `${server}/finance/get-expense-within-dates`,
    settle: `${server}/finance/toggle-expense-paid`,
    edit: `${server}/finance/expense/edit`,
    editWriteOffItem: `${server}/finance/edit-write-off-item`,
    incomeStatement: `${server}/finance/income-statement`,
    add: `${server}/finance/expense/add`,
    users: `${server}/finance/users`,
    userStatement: `${server}/finance/user-statement`,
    delete: `${server}/finance/expense/delete`
  },
  account: {
    info: `${server}/account/info`,
    pay: `${server}/account/pay`,
    addPay: `${server}/account/add-pay`,
    changePassword: `${server}/account/change-password`
  },
  import: {
    processReceipt: `${server}/import/process-receipt`,
    detectText: `${server}/import/detect-text`,
    processCsv: `${server}/import/process-csv`,
    batchFromCsv: `${server}/import/batch-from-csv`,
    getImportFormInfo: `${server}/import/import-form-info`,
    getAutocompleteBatchInfo: `${server}/import/autocomplete-batch-info`,
    skus: `${server}/import/skus`,
    items: `${server}/import/items`,
    rankSkuTemplates: `${server}/import/rank-sku-templates`,
    manual: {
      one: `${server}/import/add-one`
    },
    sku: {
      search: `${server}/sku/search`,
      update: `${server}/sku/update`,
      merge: `${server}/sku/merge`,
      getById: `${server}/sku/get-by-id`,
      checkBarcode: `${server}/sku/check-barcode`
    }
  },
  store: {
    search: `${server}/store/search`,
    getSearchCount: `${server}/store/search-count`,
    editSkuMultiple: `${server}/store/edit-sku-multiple`
  },
  operation: {
    todo: {
      get: `${server}/operation/todo/get`,
      add: `${server}/operation/todo/add`,
      toggle: `${server}/operation/todo/toggle-status`,
      delete: `${server}/operation/todo/delete`,
      update: `${server}/operation/todo/update`
    },
    channel: {
      get: `${server}/operation/channel/get`,
      merge: `${server}/operation/channel/merge`,
      rename: `${server}/operation/channel/rename`,
      add: `${server}/operation/channel/add`
    },
    location: {
      get: `${server}/operation/location/get`,
      merge: `${server}/operation/location/merge`
    }
  }
}

export const Url = Api



// WEBPACK FOOTER //
// ./src/app/config/api.config.ts